import React from 'react';
import { Link as LinkInternal } from '../../web.common';

export const DetailsRightBar = ({ children }) => (
  <aside className='details-sidebar' style={{ right: '0', overflowY: 'auto' }}>
    <nav className='menu-vertical' role='tablist'>
      {children}
    </nav>
  </aside>
);

export const NoLink = ({ children }) => (<div className='no-link-entry'>{children}</div>);

export const Divider = ({ children }) => (<div className='divider'>{children}</div>);

export const Link = ({ children, to, style }) => (
  <LinkInternal style={style} to={to} appearance='buttonWrap'>
    {children}
  </LinkInternal>
);

export const Action = ({ children, action, disabled }) => {
  const classes = ['action-entry'];

  if (disabled) {
    classes.push('disable');
  }

  return (
    <div
      onClick={() => {
        action();
      }}
      className={classes.join(' ')}
    >
      {children}
    </div>
  );
};